import {
  Box,
  Divider,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Grid,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { UserSidebar } from "../_shared/Sidebar";
import { CourseIcon } from "../../_shared/CourseIcon";
import {
  useCoursesVisibleToAllUserGroupsQuery,
  useMyUserGroupQuery,
} from "./index.generated";
import { WhiteOutlineButton } from "../../_shared/Buttons";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { CreateCourseButton } from "../_shared/CreateCourseButton";
import { RequestPolicy } from "urql";

export const UserTop = () => {
  const navigate = useNavigate();

  const context = useMemo(
    () => ({
      requestPolicy: "network-only" as RequestPolicy,
    }),
    []
  );
  const [visibleCoursesRes] = useCoursesVisibleToAllUserGroupsQuery({
    context,
  });
  const visibleCourses =
    visibleCoursesRes.data?.coursesVisibleToAllUserGroups || [];

  const [searchedWord, setSearchedWord] = useState("");

  const [filteredCourses, setFilteredCourses] = useState(visibleCourses || []);

  useEffect(() => {
    if (searchedWord === "") {
      setFilteredCourses(visibleCourses);
      return;
    }
    const filtered = visibleCourses.filter((course) => {
      return course.name.includes(searchedWord);
    });
    setFilteredCourses(filtered);
  }, [searchedWord, visibleCoursesRes]);

  const [myUserGroupRes] = useMyUserGroupQuery();

  const myUserGroup = myUserGroupRes.data?.myUserGroup;
  if (!myUserGroup) return null;

  const isActiveRouteChangeAlertFlag = useMemo(() => {
    return myUserGroupRes.data?.appConfig.routeChangeAlert;
  }, [myUserGroupRes.data?.appConfig.routeChangeAlert]);

  const myLatestCourses = myUserGroup.courses
    .sort((a, b) => {
      if (a.updatedAt > b.updatedAt) return -1;
      else {
        return 1;
      }
    })
    .slice(0, 5);

  return (
    <Flex w="full">
      <UserSidebar />
      <Box bgColor={"#16181a"} color="white" flexGrow={1} p="10">
        {/* Recently modified courses */}

        <Box py={4}>
          <Flex
            flexDir="row"
            flexWrap="wrap"
            justifyContent="space-between"
            py={2}
            my={4}
            alignItems="center"
          >
            <Text
              fontSize="4xl"
              fontWeight="bold"
              noOfLines={1}
              justifyItems="center"
            >
              最近編集したコース
            </Text>
            <Flex gap={2} justifyItems="center">
              <WhiteOutlineButton
                onClick={() => navigate("/courses")}
                label={"全てのコースを見る"}
              />
              <CreateCourseButton />
            </Flex>
          </Flex>
          <Grid templateColumns="repeat(5, 1fr)" gap={8} mb={4}>
            {myLatestCourses.map((course, idx) => {
              return (
                <CourseIcon
                  key={course.id}
                  course={course}
                  isViewMode={false}
                  isActiveRouteChangeAlertFlag={isActiveRouteChangeAlertFlag}
                />
              );
            })}
          </Grid>
        </Box>
        <Divider my="8" />
        {/* Other users' courses */}
        <Box py={4}>
          <Flex
            flexDir="row"
            flexWrap="wrap"
            justifyContent="space-between"
            py={2}
            my={4}
            alignItems="center"
          >
            <Text fontSize="4xl" fontWeight="bold" noOfLines={1}>
              各特約店のリリース済みのコース
            </Text>
            <InputGroup
              maxW={300}
              w={"full"}
              display={{ base: "none", md: "flex" }}
            >
              <Input
                placeholder="検索"
                _placeholder={{ color: "gray.500" }}
                onChange={(event) => {
                  setSearchedWord(event.target.value);
                }}
              />

              <InputRightElement
                pointerEvents="none"
                children={<SearchIcon color="gray.500" />}
              />
            </InputGroup>
          </Flex>
          {filteredCourses.length === 0 ? (
            <Text fontSize={20} fontWeight="bold">
              該当するコースが存在しません。
            </Text>
          ) : (
            <Grid templateColumns="repeat(5, 1fr)" gap={8} mb={4} w="full">
              {filteredCourses.map((course) => {
                return (
                  <CourseIcon
                    key={course.id}
                    course={course}
                    userGroupName={course.userGroup.name}
                    isActiveRouteChangeAlertFlag={isActiveRouteChangeAlertFlag}
                  />
                );
              })}
            </Grid>
          )}
        </Box>
      </Box>
    </Flex>
  );
};
